export default function HeroComponent() {
    return (
        <div className="overflow-hidden py-24">
            <div className="container mx-auto px-4">
                <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-2">
                    <div className="lg:pr-8 lg:pt-4">
                        <div className="lg:max-w-lg">
                            <h2 className="text-base font-semibold leading-7 text-indigo-600" data-aos="fade-right">Meta Akdeniz</h2>
                            <p className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl" data-aos="fade-right">Dijital Çağda Söz Sahibi Olun</p>
                            <p className="mt-6 text-lg leading-8 text-gray-600" data-aos="fade-right">
                            İşinizi dijital dünyaya taşıyın. İnternet sitenizi oluşturun, sosyal medya hesaplarınızı yönetin, reklam kampanyaları oluşturun ve daha fazlasını yapın.
                            </p>
                        </div>
                    </div>
                    <img
                        src="/icons/hero.svg"
                        alt="hero image"
                        className="w-[38rem] h-[35rem] -mt-24 sm:w-[57rem] md:-ml-4 lg:-ml-0"
                        width={2432}
                        height={500}
                        data-aos="fade-top"
                    />
                </div>
            </div>
        </div>
    )
}
